import React, { useMemo } from 'react';
import { useImqBrokerHealthQuestionnaireParams } from 'global/hooks/useImqBrokerHealthQuestionnaireParams';
import ImqBrokerHealthQuestionnaireEntryPageStore, {
  ImqBrokerHealthQuestionnaireEntryPageStoreContext,
} from 'store/pages/quote/imq-add-employees/health-questionnaire-entry/pageStore';
import { PageContent } from 'components/quote/imq-add-employees/health-questionnaire-entry';

const ImqBrokerHealthQuestionnaireEntryPage: React.FC = () => {
  const domainParams = useImqBrokerHealthQuestionnaireParams();

  const pageStore = useMemo(
    () => new ImqBrokerHealthQuestionnaireEntryPageStore(domainParams),
    [
      domainParams.groupId,
      domainParams.periodId,
      domainParams.cartId,
      domainParams.subscriberId,
      domainParams.entityId,
    ],
  );

  return (
    <ImqBrokerHealthQuestionnaireEntryPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ImqBrokerHealthQuestionnaireEntryPageStoreContext.Provider>
  );
};

export default ImqBrokerHealthQuestionnaireEntryPage;
